/**
 * Quotes Module
 */
(function(){
    'use strict';
    angular.module('elogbooks.admin.satisfactionsurveylines', []);
})();
